// extracted by mini-css-extract-plugin
module.exports = {"select":"FormSelect_select__nyQKw","error":"FormSelect_error___rLpg","rotation":"FormSelect_rotation__5klg2"};